// extracted by mini-css-extract-plugin
export default {"form":"HeatInstallationForm-module__form-KA79en"};